import api from "./api";

api.install = function(Vue) {
  Vue.prototype.$api = api;
};

export default api;
